<form [formGroup]="stateForm">
  <div class="row g-4 mb-3">
    <div class="col-sm-6 col-md-4">
      <div class="form-group">
        <label for="startState" class="form-label">Start State</label>
        <select
          id="startState"
          formControlName="startState"
          class="form-select">
          <option value="">Select Start State</option>
          <option *ngFor="let state of availableStartStates" [value]="state">
            {{ state }}
          </option>
        </select>
      </div>
    </div>
    <div class="col-sm-6 col-md-4">
      <div class="form-group">
        <label for="event" class="form-label">Event</label>
        <select
          id="event"
          formControlName="event"
          class="form-select"
          [disabled]="!stateForm.get('startState')?.value">
          <option value="">Select Event</option>
          <option *ngFor="let event of availableEvents" [value]="event">
            {{ event }}
          </option>
        </select>
      </div>
    </div>
  </div>
  <div class="row g-4">
    <div class="col-sm-6 col-md-4">
      <div class="form-group">
        <label for="endStateType" class="form-label">End State</label>
        <select
          id="endStateType"
          formControlName="endStateType"
          class="form-select"
          [disabled]="!stateForm.get('event')?.value">
          <option value="">Select End State</option>
          <option
            *ngFor="let endState of availableEndStates"
            [value]="endState.type">
            {{ endState.code }}
          </option>
        </select>
      </div>
    </div>
    <div class="col-sm-6 col-md-4">
      <div class="form-group">
        <label for="actionType" class="form-label">Action Type</label>
        <select
          id="actionType"
          formControlName="actionType"
          class="form-select"
          [disabled]="!stateForm.get('endStateType')?.value">
          <option value="">Select Action Type</option>
          <option *ngFor="let type of actionTypes" [value]="type">
            {{ getActionTypeLabel(type) }}
          </option>
        </select>
      </div>
    </div>
  </div>
</form>
